// Per-board preferences persisted to localStorage. We keep filters,
// sort config, scostamento band selection and view mode so the user
// finds the same setup on return.
//
// SECURITY NOTE: localStorage is readable by any JS running on this
// origin. We only store non-sensitive UI state here (filters, sort). We
// validate the JSON shape on read so a tampered value can't crash the
// app or inject arbitrary React props downstream.

const KEY = (boardId) => `immomap:board:${boardId}:prefs:v1`;

// Whitelist of shape keys we accept back from localStorage. Anything
// else is stripped on read.
const ALLOWED_KEYS = new Set([
  "filters", "sortConfig", "scostBands", "viewMode", "columnOrder",
]);

const sanitize = (obj) => {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) return null;
  const out = {};
  for (const k of Object.keys(obj)) {
    if (ALLOWED_KEYS.has(k)) out[k] = obj[k];
  }
  return out;
};

export const loadBoardPrefs = (boardId) => {
  if (!boardId || typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY(boardId));
    if (!raw) return null;
    return sanitize(JSON.parse(raw));
  } catch (err) {
    console.warn("[boardPrefs] load failed:", err);
    return null;
  }
};

export const saveBoardPrefs = (boardId, prefs) => {
  if (!boardId || typeof window === "undefined") return;
  const clean = sanitize(prefs);
  if (!clean) return;
  try {
    window.localStorage.setItem(KEY(boardId), JSON.stringify(clean));
  } catch (err) {
    // Quota exceeded or blocked. Non-critical — log for observability.
    console.warn("[boardPrefs] save failed:", err);
  }
};

export const clearBoardPrefs = (boardId) => {
  if (!boardId || typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY(boardId));
  } catch (err) {
    console.warn("[boardPrefs] clear failed:", err);
  }
};
